import { RouteProps, routes } from 'constants/routes'
import { useUserAuthorizations } from 'modules/sso/operations'
import React from 'react'
import { Route, RouteProps as ReactRouteProps } from 'react-router-dom'
import { useQueryParams } from 'utils'
import { LinkAccountConfirmationPage } from '../LinkAccountConfirmationPage'
import { RedirectingToIdentityProvider } from '../RedirectingToIdentityProvider'
import { SignInToLinkAccountPage } from '../SignInToLinkAccountPage'
import { SsoErrorPage } from '../SsoErrorPage'
import SsoSignInView from '../SsoSignInView'
import SsoSuccessfulSignInView from '../SsoSuccessfulSignInView'
import { SsoTosPage } from '../SsoTosPage'

export const SignInRoute: React.FC<RouteProps<'SSO_SIGN_IN'>> = props => {
  const { source, team } = useQueryParams<'SSO_SIGN_IN'>()

  if (source === 'sketch' && team) {
    return <RedirectingToIdentityProvider />
  }

  return <SsoSignInView {...props} />
}

const LinkAccountRoute = () => {
  const { hasPersonalAuthorization } = useUserAuthorizations()

  if (hasPersonalAuthorization) {
    return <LinkAccountConfirmationPage />
  } else {
    return <SignInToLinkAccountPage />
  }
}

export const SsoRoutes: React.FC<ReactRouteProps> = () => {
  return (
    <>
      <Route
        exact
        path={routes.SSO_SIGN_IN.template()}
        component={SignInRoute}
      />

      <Route
        exact
        path={routes.SSO_ERROR.template()}
        component={SsoErrorPage}
      />

      <Route
        exact
        path={routes.SSO_SUCCESSFUL_SIGN_IN.template()}
        component={SsoSuccessfulSignInView}
      />

      <Route
        exact
        path={routes.SSO_LINK_ACCOUNT.template()}
        component={LinkAccountRoute}
      />

      <Route exact path={routes.SSO_TOS.template()} component={SsoTosPage} />
    </>
  )
}
